<template>
  <ul class="hospitalLabel" :class="{ '-l': isLarge, '-online': isOnline }">
    <li v-for="(item, i) in items" :key="i">{{ item }}</li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'HospitalLabel',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    isOnline: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalLabel {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  > li {
    font-size: 1rem;
    font-weight: 500;
    background-color: #fffccb;
    padding: 4px;
    line-height: 1;
    margin-right: 4px;
    margin-bottom: 4px;
  }

  &.-l {
    > li {
      font-size: 1.2rem;
    }
  }

  &.-online {
    display: inline-flex;
    margin-right: 8px;
    > li {
      font-size: 1.2rem;
    }
  }
}
</style>
